import { render, staticRenderFns } from "./CampaignSetupPixelsList.vue?vue&type=template&id=8ca4b114&"
import script from "./CampaignSetupPixelsList.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixelsList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixelsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports